import { render, staticRenderFns } from "./DashboardPdf.vue?vue&type=template&id=448a8887"
import script from "./DashboardPdf.vue?vue&type=script&lang=js"
export * from "./DashboardPdf.vue?vue&type=script&lang=js"
import style0 from "./DashboardPdf.vue?vue&type=style&index=0&id=448a8887&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports